import * as z from "zod";

export const getBillOfMaterialsReevaluationStatus = {
  name: "getBillOfMaterialsReevaluationStatus" as const,
  input: z.object({ workflowId: z.string() }),
  output: z.object({
    state: z.enum(["running", "completed", "failed", "not_found"]),
    progress: z
      .object({
        total: z.number(),
        processed: z.number(),
        updated: z.number(),
        unchanged: z.number(),
        skipped: z.number(),
        failed: z.number(),
      })
      .nullable(),
  }),
};
